import * as i0 from '@angular/core';
import { Injectable, ViewChild } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import { environment } from 'environment-configurations';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as i2 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { map as map$1 } from 'rxjs/operators';
import * as i1$1 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'app-services-library';

class APIOrganizeDocuments {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    resetOrganizeDocuments(visaType, caseType, caseId) {
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/organizeDocuments/reset`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getOrganizeDocuments(visaType, caseType, caseId) {
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/organizeDocuments`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    postOrganizedDocument(visatype, caseType, caseId, payload) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/organizeDocuments`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
APIOrganizeDocuments.ɵfac = function APIOrganizeDocuments_Factory(t) { return new (t || APIOrganizeDocuments)(i0.ɵɵinject(i1.HttpClient)); };
APIOrganizeDocuments.ɵprov = i0.ɵɵdefineInjectable({ token: APIOrganizeDocuments, factory: APIOrganizeDocuments.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIOrganizeDocuments, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseOrganizeDocumentsLibraryService {
    constructor(toastr, store, apiService, stepStatusUpdatePayloadCostruction, appServicesLibraryService) {
        this.toastr = toastr;
        this.store = store;
        this.apiService = apiService;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.appServicesLibraryService = appServicesLibraryService;
        this.newNode = [];
        this.titleSheetButtonEnabled = true;
        this.observableSubscription$ = new Subject();
        this.disabledControls = false;
    }
    loadInit() {
        this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.stepDetails = data;
            this.organizeDocumentsForm.reset();
            this.getOrgranizedDocument();
            this.toggleControlsStatus();
        });
    }
    afterViewInit() {
        this.organizeDocumentsForm.form.valueChanges.pipe(map$1(() => this.organizeDocumentsForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    onDrop(event) {
        this.store.dispatch(new MarkDirtyFormAction({
            dirty: true
        }));
        if (event.dropNode.class == 'custom') {
            event.dragNode.data["class"] = "customChild";
        }
        else {
            event.dragNode.data["class"] = "";
        }
        if (event.originalEvent.currentTarget.className === 'p-treenode-droppoint ng-star-inserted p-treenode-droppoint-active') {
            if (event.dragNode.type == "child" && event.dropNode.type == "parent")
                event.reject();
            else
                event.accept();
        }
        else {
            if (event.originalEvent.currentTarget.className === "p-treenode-content p-treenode-dragover") {
                if (event.dragNode.type == event.dropNode.type) {
                }
                else
                    event.accept();
            }
            else
                event.accept();
        }
    }
    renameCustomTitleSheet(event) {
        this.toastr.success("Title Sheet Renamed", 'Success');
        //this.inplaceEditor.onDeactivate.emit(event);
        this.inplaceEditorCustom.deactivate(event);
    }
    postOrganizedDocument() {
        let organizedList = [];
        this.supportingDocumentsTree.forEach((element, index) => {
            let obj = {
                "titleSheetName": element != "custom" ? element["data"]["titleSheetName"] : element["data"]["categoryName"],
                "titleSheetSequnceNo": index,
                "titleSheetId": element["data"]["titleSheetId"],
                "documentTypes": []
            };
            if (element["children"] != undefined) {
                element["children"].forEach((doc, subIndex) => {
                    let child = {
                        'docName': doc["data"]["docName"],
                        "fileCategory": doc["data"]["fileCategory"],
                        "titleSheetDetailSequenceNo": subIndex + index,
                        "titleSheetDetailId": doc["data"]["titleSheetDetailId"],
                        'documents': doc["data"]["documents"]
                    };
                    obj["documentTypes"].push(child);
                });
            }
            organizedList.push(obj);
        });
        this.apiService.postOrganizedDocument(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, organizedList)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.titleSheetButtonEnabled = true;
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    viewDocument(item) {
        const docPath = item.substring(23);
        window.open(`${environment.docs}${docPath}`, "_blank");
    }
    deleteDocument(item) {
        // this.rfeService.deleteRFEDocument(this.SubTaskOverView['id'], item).subscribe((response: any) => {
        //   if (response) {
        //     this.toastr.success(response.message);
        //     this.getOrgranizedDocument();
        //   }
        // });
        // const deleteDialogRef = this.dialogService.open(DeleteDialogComponent, DeleteDialogConfigurations);
        // deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).subscribe((response: boolean) => {
        //   if (response) {
        //     this.apiService.deleteOrganizedDocuments(this.inputData.superTaskId, this.inputData.subTaskId, subexperiencelist.id, item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
        //       this.toastr.success(response.message);
        //       this.getOrgranizedDocument();
        //     })
        //   }
        // });
    }
    getOrgranizedDocument() {
        let tempData = [];
        this.apiService.getOrganizeDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.newTitleSheetSequenceNo = response.data[response.data.length - 1]["titleSheetSequnceNo"] + 1;
            response.data.forEach((element) => {
                let obj = {
                    data: element,
                    type: 'parent',
                    children: []
                };
                element.documentTypes.sort(function (a, b) {
                    if (null == a.titleSheetDetailSequenceNo) {
                        a.titleSheetDetailSequenceNo = Math.max(...element.documentTypes.map(o => o.titleSheetDetailSequenceNo)) + 1;
                    }
                    return a.titleSheetDetailSequenceNo - b.titleSheetDetailSequenceNo;
                });
                // //IM-13595- removing Other Doc Type in case if Other doc type is also having documents array.
                // element.documentTypes.filter(x => x.present == true && (x.docName !== 'Other')).forEach(doc => {
                //   obj.children.push({
                //     data: doc,
                //     type: 'child'
                //   });
                // });
                //IM-14394- fix other documents type files are not coming.
                element.documentTypes.filter(x => x.present == true).forEach(doc => {
                    obj.children.push({
                        data: doc,
                        type: 'child'
                    });
                });
                if (obj.children && obj.children.length > 0) {
                    tempData.push(obj);
                }
            });
            this.supportingDocumentsTree = tempData;
            this.supportingDocumentsTree.forEach(node => {
                this.expandRecursive(node, true);
            });
        });
    }
    resetOrganizedDocument() {
        this.apiService.resetOrganizeDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                this.getOrgranizedDocument();
            }
        });
    }
    expandRecursive(node, isExpand) {
        node.expanded = isExpand;
        if (node.children) {
            node.children.forEach(childNode => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
BaseOrganizeDocumentsLibraryService.ɵfac = function BaseOrganizeDocumentsLibraryService_Factory(t) { return new (t || BaseOrganizeDocumentsLibraryService)(i0.ɵɵinject(i1$1.ToastrService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(APIOrganizeDocuments), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.AppServicesLibraryService)); };
BaseOrganizeDocumentsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseOrganizeDocumentsLibraryService, factory: BaseOrganizeDocumentsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseOrganizeDocumentsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.ToastrService }, { type: i2.Store }, { type: APIOrganizeDocuments }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.AppServicesLibraryService }]; }, { inplaceEditor: [{
            type: ViewChild,
            args: ['inplace', { static: false }]
        }], inplaceEditorCustom: [{
            type: ViewChild,
            args: ['inplaceCustom', { static: false }]
        }] }); })();

/*
 * Public API Surface of base-organize-documents-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIOrganizeDocuments, BaseOrganizeDocumentsLibraryService };
//# sourceMappingURL=base-organize-documents-library.js.map
